
import { FC } from "react";
import { AuthenticatedLayout } from "../../layouts";
import { StubSettingsList } from "../../components/StubSettingsList";

export interface IStubSettingsListPage {}

export const StubSettingsListPage: FC<IStubSettingsListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Stub Settings List"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Stub Settings", navigateTo: "/settings/stub/list" },
      ]}
      mainContents={<StubSettingsList />}
    />
  );
};
